import { useSelector } from 'react-redux';
import { UserRole } from '../store/auth/types';
import RootState from '../store/types';

export default function useUserRole() {
  const { role } = useSelector((state: RootState) => state.auth);
  return { role, isAdmin: role === UserRole.ADMIN };
}
